import { ROUTES } from '@constants/routes';
import { CTAdminBreadcrumbs } from '../components/breadcrumbs/CTAdminBreadcrumbs';
import StockExchangeSettings from '@features/stock-exchange-settings';

export const StockExchangeSettingsRoute = () => {
  return (
    <StockExchangeSettings
      baseRoute={ROUTES.ACCOUNT_SETTINGS}
      BreadcrumbsComponent={CTAdminBreadcrumbs}
    />
  );
};
